/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Fragment } from 'react';
import env from 'env';
import { useEffect, useState } from 'react';
//import { MdArrowDropDownCircle } from "react-icons/md";
//import { useParams } from 'react-router-dom';
//import { Loading } from 'components';

// class CategoryClass {
//     categoryName;
//     categoryCode;
//     filters;
//     constructor(categoryName, categoryCode, filters = []) {
//         this.categoryName = categoryName;
//         this.filters = filters;
//         this.categoryCode = categoryCode;
//     }
// }

class FilterClass {
    filterName;
    filterId;
    filterCode;
    filterSeq;
    uniqeIdInOnlyHere;
    constructor(props) {
        this.filterId = props.filterId;
        this.filterName = props.filterName;
        this.filterCode = props.filterCode;
        this.uniqeIdInOnlyHere = props.uniqeIdInOnlyHere;
        this.filterSeq = this.filterSeq || 100;
    }
}

//filterName = '', filterId = '', filterCode = '', uniqeIdInOnlyHere

export function FilterEdit(props) {

    // const [categories, setCategories] = useState({
    //     category_1: new CategoryClass('Family Friendly', 'category_1'),
    //     category_2: new CategoryClass('Waterfront', 'category_2'),
    //     category_3: new CategoryClass('Bush', 'category_3'),
    //     category_4: new CategoryClass('Style', 'category_4'),
    //     category_5: new CategoryClass('EV', 'category_5')
    // });

    const [categories, setCategories] = useState();
    const [submitTrigger, setSubmitTrigger] = useState(0);
    const [errors, setErrors] = useState();
    const [openCategory, setOpenCategory] = useState({
        // category_1 : false,
        // category_2 : false,
        // category_3 : false,
        // category_4 : false,
        // category_5 : false,
        // category_6 : false,
        category_1 : true,
        category_2 : true,
        category_3 : true,
        category_4 : true,
        category_5 : true,
        category_6 : true,
    });

    function onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        setSubmitTrigger(submitTrigger + 1);
    }

    function addFilter({ categoryCode }) {

        function addFilterFuc(categoriesFilterItems) {
            let _data = {
                filterName: "",
                uniqeIdInOnlyHere: categoryCode + '_' + (categoriesFilterItems.length + 1)
            };
            categoriesFilterItems.push(new FilterClass(_data));
        }

        switch (categoryCode) {
            case 'category_1':
                addFilterFuc(categories.category_1.filters);
                break;
            case 'category_2':
                addFilterFuc(categories.category_2.filters);
                break;
            case 'category_3':
                addFilterFuc(categories.category_3.filters);
                break;
            case 'category_4':
                addFilterFuc(categories.category_4.filters);
                break;
            case 'category_5':
                addFilterFuc(categories.category_5.filters);
                break;
            case 'category_6':
                addFilterFuc(categories.category_6.filters);
                break;
            default:
                break;
        }
        setCategories({ ...categories });
    }

    function removeFilter({ categoryCode, uniqeIdInOnlyHere }) {
        function removeFilterItem(categoriesFilterItems) {
            if (!window.confirm("Remove this??")) return;

            for (let i in categoriesFilterItems) {
                if (categoriesFilterItems[i].uniqeIdInOnlyHere === uniqeIdInOnlyHere) {
                    categoriesFilterItems.splice(i, 1);
                    break;
                }
            }
        }

        switch (categoryCode) {
            case 'category_1':
                removeFilterItem(categories.category_1.filters);
                break;
            case 'category_2':
                removeFilterItem(categories.category_2.filters);
                break;
            case 'category_3':
                removeFilterItem(categories.category_3.filters);
                break;
            case 'category_4':
                removeFilterItem(categories.category_4.filters);
                break;
            case 'category_5':
                removeFilterItem(categories.category_5.filters);
                break;
            case 'category_6':
                removeFilterItem(categories.category_6.filters);
                break;
            default:
                break;
        }

        setCategories({ ...categories });
    }

    function handChangeForFilter(el) {

        const valueSeq = el.valueSeq;
        const valueName = el.valueName;
        const elCategoryCode = el.categoryCode;
        const elUniqeIdInOnlyHere = el.uniqeIdInOnlyHere;

        function updatedFilterContents(filterData, valueSeqData, valueNameData) {
            filterData.filterName = valueNameData ? valueNameData : filterData.filterName;
            filterData.filterSeq = valueSeqData ? valueSeqData : filterData.filterSeq;
        }

        switch (elCategoryCode) {
            case 'category_1':
                let _filter1 = categories.category_1.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter1, valueSeq, valueName);
                break;
            case 'category_2':
                let _filter2 = categories.category_2.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter2, valueSeq, valueName);
                break;
            case 'category_3':
                let _filter3 = categories.category_3.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter3, valueSeq, valueName);
                break;
            case 'category_4':
                let _filter4 = categories.category_4.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter4, valueSeq, valueName);
                break;
            case 'category_5':
                let _filter5 = categories.category_5.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter5, valueSeq, valueName);
                break;
            case 'category_6':
                let _filter6 = categories.category_6.filters.find(el => el.uniqeIdInOnlyHere === elUniqeIdInOnlyHere);
                updatedFilterContents(_filter6, valueSeq, valueName);
                break;
            default:
                break;
        }

        setCategories({ ...categories });
    }

    function openCategoryFun({ categoryCode }){
        switch (categoryCode) {
            case 'category_1':
                openCategory.category_1 = !openCategory.category_1;
                break;
            case 'category_2':
                openCategory.category_2 = !openCategory.category_2;
                break;
            case 'category_3':
                openCategory.category_3 = !openCategory.category_3;
                break;
            case 'category_4':
                openCategory.category_4 = !openCategory.category_4;
                break;
            case 'category_5':
                openCategory.category_5 = !openCategory.category_5;
                break;
            case 'category_6':
                openCategory.category_6 = !openCategory.category_6;
                break;
            default:
                break;
        }

        setOpenCategory({...openCategory});
    }

    useEffect(() => {

        const abortController = new AbortController();
        const signal = abortController.signal;

        const fetchData = async () => {
            const res = await fetch(env.apiBase + "/api/atdwfilteradmin/getatdwfilers", {
                method: 'get',
                signal: signal,
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await res.json();
            setCategories(data);
        }

        fetchData();
        return function cleanup() {
            abortController.abort();
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {

        if (submitTrigger === 0) {
            return;
        }

        setErrors(null);

        const abortController = new AbortController();
        const signal = abortController.signal;

        const fetchData = async () => {
            const res = await fetch(env.apiBase + "/api/atdwfilteradmin/savefilers", {
                method: 'post',
                signal: signal,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    categories: categories
                })
            });

            const data = await res.json();

            if (data.errors && data.errors.length > 0) {
                setErrors(data.errors);
            }
            else {
                window.location.reload();
            }

        }

        fetchData();
        return function cleanup() {
            abortController.abort();
        }

        // eslint-disable-next-line
    }, [submitTrigger]);

    return (
        <Fragment>
            <form onSubmit={onSubmit} autoComplete="off">

                <h1> Edit Filters </h1>
                {/* <div>
                    <button type="submit" className="btn btn-primary"> Save Filters </button>
                </div> */}
                <hr />

                {
                    categories && categories.category_1 &&
                    <Fragment>
                        <FilterContainer category={categories.category_1} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_1} />
                        <hr />
                    </Fragment>
                }
                {
                    categories && categories.category_2 &&
                    <Fragment>
                        <FilterContainer category={categories.category_2} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_2} />
                        <hr />
                    </Fragment>
                }
                {
                    categories && categories.category_3 &&
                    <Fragment>
                        <FilterContainer category={categories.category_3} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_3} />
                        <hr />
                    </Fragment>
                }
                {
                    categories && categories.category_4 &&
                    <Fragment>
                        <FilterContainer category={categories.category_4} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_4} />
                        <hr />
                    </Fragment>
                }
                {
                    categories && categories.category_5 &&
                    <Fragment>
                        <FilterContainer category={categories.category_5} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_5} />
                        <hr />
                    </Fragment>
                }
                {
                    categories && categories.category_6 &&
                    <Fragment>
                        <FilterContainer category={categories.category_6} addFilter={addFilter} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} openCategoryFun = {openCategoryFun} openCategory = {openCategory.category_6} />
                        <hr />
                    </Fragment>
                }
                {
                    errors && errors.length > 0 &&
                    <div className='error__msg__container'>
                        <h4 className='errors__text'> Errors * </h4>
                        {
                            errors.map((item, index) => <div key={index}>{item.errorMessage}</div>)
                        }
                    </div>
                }
                <div>
                    <button type="submit" className="btn btn-primary"> Save Filters </button>
                </div>
            </form>
        </Fragment>
    )
}

function FilterContainer({ category, addFilter, handChangeForFilter, removeFilter, openCategoryFun, openCategory }) {

    return (
        <div className='row'>

            <div className='col-2'>
                <div className='filter__category__name'>
                    {category.categoryName}
                </div>
            </div>

            <div className='col-2'>
                <div className='filter__category__add__filter__btn'>
                    <button type="button" className="btn btn-primary" onClick={() => {
                        addFilter({ categoryCode: category.categoryCode });
                    }}> Add filter </button>
                    {/* <div className='filter__category__close__btn'>
                        <MdArrowDropDownCircle className={`${openCategory === true ? 'open' : 'close'}`}  onClick={() => {
                            openCategoryFun({ categoryCode: category.categoryCode })
                        }} />
                    </div> */}
                </div>
            </div>

            <div className='col-12'>
                <div className={`filter__container ${openCategory === true ? 'open' : 'close'}`}>
                    {
                        category.filters.map((item, index) => <FilterItem key={index} filter={item} categoryCode={category.categoryCode} handChangeForFilter={handChangeForFilter} removeFilter={removeFilter} />)
                    }
                </div>
            </div>

        </div>
    )
}

function FilterItem({ filter, categoryCode, handChangeForFilter, removeFilter }) {
    return (
        <div className='row filter__item__row'>
            <div className='col-md-4'>
                <label htmlFor={filter.uniqeIdInOnlyHere + '_filterName'} className="form-label"> Filter Name* </label>
                <input type="text" className="form-control" name={filter.uniqeIdInOnlyHere + '_filterName'} id={filter.uniqeIdInOnlyHere + '_filterName'} value={filter.filterName} placeholder="" onChange={(e) => {
                    handChangeForFilter({
                        valueName: e.target.value,
                        uniqeIdInOnlyHere: filter.uniqeIdInOnlyHere,
                        categoryCode: categoryCode
                    });

                }} />
            </div>
            <div className='col-md-2'>
                <label htmlFor={filter.uniqeIdInOnlyHere + '_filterSeq'} className="form-label"> Seq </label>
                <input type="number" min="0" className="form-control" id={filter.uniqeIdInOnlyHere + '_filterSeq'} name={filter.uniqeIdInOnlyHere + '_filterSeq'} value={filter.filterSeq} onChange={(e) => {
                    handChangeForFilter({
                        valueSeq: e.target.value,
                        uniqeIdInOnlyHere: filter.uniqeIdInOnlyHere,
                        categoryCode: categoryCode
                    });
                }} />
            </div>
            <div className='col-md-4'>
                <label className="form-label" style={{ visibility: 'hidden' }}>button</label>
                <button type="button" className="btn btn-primary" style={{ display: 'block' }} onClick={() => {
                    removeFilter({
                        uniqeIdInOnlyHere: filter.uniqeIdInOnlyHere,
                        categoryCode: categoryCode
                    });
                }}>
                    Remove Filter
                </button>
            </div>
        </div>
    )
}